import React, { JSX } from 'react';
import BulkSummaryHeader from 'src/components/BulkOperations/_Shared/BulkSummaryHeader/BulkSummaryHeader';

interface SummaryHeaderContentProps {
  isActivatedMode: boolean;
  isEmailMode: boolean;
  totalWalkthroughs: number;
  totalEmailsSent: number;
  emailsFailedCount: number;
  mode: 'creation' | 'activation';
}

const WalkthroughSummaryHeaderContent = ({
  totalWalkthroughs,
  totalEmailsSent,
  emailsFailedCount,
  isActivatedMode,
  isEmailMode,
  mode,
}: SummaryHeaderContentProps) => {

  const plural = totalWalkthroughs !== 1 ? 's' : '';

  let title = 'Walkthroughs Created Successfully!';

  if (mode === 'activation') {
    title = isEmailMode
      ? 'Walkthroughs Activated and Scheduled!'
      : 'Walkthroughs Activated Successfully!';
  } else if (isActivatedMode) {
    title = isEmailMode
      ? 'Walkthroughs Created, Activated, and Scheduled!'
      : 'Walkthroughs Created and Activated Successfully!';
  }

  const actionText =
    mode === 'creation'
      ? isActivatedMode
        ? 'bulk added and activated'
        : 'bulk added'
      : 'activated';

  const subtitle: JSX.Element = (
    <>
      You {actionText} <strong>{totalWalkthroughs}</strong> walkthrough{plural}.
      {isEmailMode &&
        ` Scheduling emails sent to ${totalEmailsSent} homeowners.`}
      {emailsFailedCount > 0 && isEmailMode && (
        <span className="failed-emails-note">
          ({emailsFailedCount} homeowners have no email address on file)
        </span>
      )}
    </>
  );

  return (
    <BulkSummaryHeader
      title={title}
      subtitle={subtitle}
      centered={false}
    />
  );
};

export default WalkthroughSummaryHeaderContent;
